import { z } from 'zod';

const ConfigSchema = z.object({
  cameraDisabled: z.string().transform((value) => Boolean(JSON.parse(value || 'false'))),
  photoUploadEnabled: z.string().transform((value) => Boolean(JSON.parse(value || 'false'))),
});

export const config = ConfigSchema.parse({
  cameraDisabled: import.meta.env.VITE_APP_DISABLE_CAMERA_INIT,
  photoUploadEnabled: import.meta.env.VITE_APP_ENABLE_MANUAL_PHOTO_UPLOAD,
});
